import { createAction } from 'redux-actions'

import * as constants from './constants'

export const getGoogleAnalyticsSettings = createAction(constants.GET_GOOGLE_ANALYTICS_SETTINGS)
export const getGoogleAnalyticsSettingsPending = createAction(constants.GET_GOOGLE_ANALYTICS_SETTINGS_PENDING)
export const getGoogleAnalyticsSettingsSuccess = createAction(constants.GET_GOOGLE_ANALYTICS_SETTINGS_SUCCESS)
export const getGoogleAnalyticsSettingsFailed = createAction(constants.GET_GOOGLE_ANALYTICS_SETTINGS_FAILED)

export const patchGoogleAnalytics = createAction(constants.PATCH_GOOGLE_ANALYTICS)
export const patchGoogleAnalyticsPending = createAction(constants.PATCH_GOOGLE_ANALYTICS_PENDING)
export const patchGoogleAnalyticsSuccess = createAction(constants.PATCH_GOOGLE_ANALYTICS_SUCCESS)
export const patchGoogleAnalyticsFailed = createAction(constants.PATCH_GOOGLE_ANALYTICS_FAILED)


// WEBPACK FOOTER //
// ./src/scripts/app/modules/googleAnalytics/actions.js